// The centre aim reticle. D17 shipped it as a CHARGE meter (a ring filling green→red with the predicted
// charge01); D137 retires that ring with the mechanic behind it — a shot is a shot and holding is just
// aiming, so a meter that fills toward nothing is exactly the "invisible sabotage" §1.2 describes. The
// element stays because the AERIAL cue lives on it: the ball is in YOUR strike envelope right now.
// ui/ consumes ViewState-derived values only (T-ARCH-004); this touches DOM, never game internals.

const RING_R = 18;

export class ChargeReticle {
  private readonly ring: SVGCircleElement | null;
  private readonly container: HTMLElement | null;
  private readonly circumference = 2 * Math.PI * RING_R;

  constructor(doc: Document = document) {
    this.ring = doc.getElementById('ring') as SVGCircleElement | null;
    this.container = doc.getElementById('reticle');
    if (this.ring) this.ring.style.strokeDasharray = `${this.circumference}`;
    this.update(false);
  }

  /** `aiming` = a SHOOT is held: the reticle appears (you are placing a shot), as a steady whole ring —
   *  D137 deleted the fill, because there is no longer anything for it to fill toward.
   *
   *  D113 (HB-D): `aerialReady` is the header/volley cue — the ball is in YOUR strike envelope right now,
   *  so a SHOOT press finishes it. It pulses the same ring amber (`pulse01`) because the reticle is
   *  already where the player is looking, and it reads the SAME `strikeEnvelope` the sim resolves the
   *  strike from, so the cue cannot promise a header the sim would refuse. */
  update(aiming: boolean, aerialReady = false, pulse01 = 0, armed = false): void {
    const visible = aiming || aerialReady || armed;
    if (this.container) this.container.style.display = visible ? 'block' : 'none';
    if (!this.ring || !visible) return;
    this.ring.style.strokeDashoffset = '0'; // a whole ring, always — the meter is gone (D137)
    if (aerialReady) {
      const p = Math.max(0, Math.min(1, pulse01));
      this.ring.style.stroke = `hsl(42, 95%, ${Math.round(52 + 18 * p)}%)`; // CONTACT POSSIBLE — bright amber
      return;
    }
    // D135: "press registered" is its own state. A declared finish that has no contact yet used to look
    // exactly like no press at all, which is what made a swallowed arm impossible to learn from.
    this.ring.style.stroke = armed ? 'hsl(42, 60%, 42%)' : 'hsl(120, 90%, 55%)';
  }
}
